export default "__VITE_ASSET__FMgOv3IN__"